let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("eh9w8")).then(() => parcelRequire('bcTDG'));